module.exports = __webpack_public_path__ + "img/step1-5.7911e9ce.png";